import styled from "styled-components";

export const TransactionyProcessingContainer = styled.section`
  /* width: 100%; */
  padding: 10px 25px;
  display: block;
  box-sizing: border-box;
  margin: 20px 20px;

  .heading {
    background-color: #ffffff;
    padding-top: 10px;

    padding-left: 10px;
    padding-right: 10px;
    border-radius: 4px;
    color: #2f4f4f;

    h4 {
      color: #2f4f4f !important;
    }
  }
`;

export const TableWrapper = styled.div`
  /* display: flex; */
`;
